<template>
  <b-row>
      <b-col xs='12' md='6' lg='3'>
        <Widget
          title="<h5>Broken Appointments</h5>"
          close collapse customHeader
        >
          <div class="text-center">
            <div class="easy-pie-chart-md mb-lg" id="easy-pie1" data-percent="73">
              73
            </div>
          </div>
        </Widget>
      </b-col>
      <b-col xs='12' md='6' lg='3'>
        <Widget
          title="<h5>Overdue Recall</h5>"
          close collapse customHeader
        >
          <div class="text-center">
            <div class="easy-pie-chart-md mb-lg" id="easy-pie2" data-percent="65">
              65
            </div>
          </div>
        </Widget>
      </b-col>
      <b-col xs='12' md='6' lg='3'>
        <Widget
          title="<h5>Unscheduled Teatment</h5>"
          close collapse customHeader
        >
          <div class="text-center">
            <div class="easy-pie-chart-md mb-lg" id="easy-pie3" data-percent="30">
              30
            </div>
          </div>
        </Widget>
      </b-col>
      <b-col xs='12' md='6' lg='3'>
        <Widget
          title="<h5>Other</h5>"
          close collapse customHeader
        >
          <div class="text-center">
            <div class="easy-pie-chart-md mb-lg" id="easy-pie4" data-percent="75">
              75
            </div>
          </div>
        </Widget>
      </b-col>
    </b-row>
</template>

<script>

import Widget from '@/components/Widget/Widget';

export default {
  name: 'TaskHeader',
  components: { Widget}
  //props: ['title', 'name', 'photo', 'date', 'changeCompose'],
};
</script>

<style src="./TaskHeader.scss" lang="scss" scoped />
